/* Reuse merchant-managed device links and the original Amazon country controls. */
if (!customElements.get('device-shortcuts')) {
  customElements.define('device-shortcuts', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.origin = document.createComment('mobile device shortcuts');
      this.before(this.origin);
      this.mobile = matchMedia('(max-width: 719px)');
      this.place = () => {
        const hero = document.querySelector('#site-main .slideshow')?.closest('.shopify-section');
        if (this.mobile.matches && hero && !window.Shopify?.designMode) hero.after(this);
        else if (this.origin.isConnected) this.origin.after(this);
      };
      this.mobile.addEventListener('change', this.place);
      this.place();
    }
  });
}
if (!customElements.get('mobile-buy-jump')) {
  customElements.define('mobile-buy-jump', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const target = document.getElementById('amazear-product-buy');
      if (!target || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        this.hidden = entries[0].isIntersecting;
      }, {rootMargin: '-100px 0px 0px 0px'});
      this.observer.observe(target);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
